import { IVideo } from "../hooks/useFetchVideos";

export const sanitizePathSegment = (value: any): string =>
    String(value ?? "")
        .trim()
        .replace(/[^a-zA-Z0-9-_]+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");

// Returns the folder portion of the iconik path, without a trailing slash
// and without a filename. Shared by video and thumbnail uploads.
export const buildVideoFolder = (video: IVideo, project?: any): string => {
    const proj: any = project || (video as any).project || {};
    const projectId = proj?.id ?? (video as any).projectId ?? "";
    const projectName = sanitizePathSegment(proj?.title || proj?.project_name || "project");

    const brands: any[] = proj?.brands || [];
    const rmnBrand = brands.find((b: any) => b?.rmn);
    const regularBrand = brands.find((b: any) => !b?.rmn);

    const ch: any = (video as any).content_channel || {};
    const channelId = ch.id ?? (video as any).content_channel_id ?? null;
    const hasChannel = channelId !== null && channelId !== "";
    const channelFolder = hasChannel
        ? `${sanitizePathSegment(ch.name || "channel")}_channel_${channelId}`
        : "";

    const projectFolder = `${projectName}_${projectId}`;
    const tail = hasChannel
        ? `${projectFolder}/${channelFolder}`
        : projectFolder;

    if (rmnBrand) {
        const parentBrand = sanitizePathSegment(rmnBrand.name);
        const brand = sanitizePathSegment(regularBrand?.name || "brand");
        return `/${parentBrand}/RMN-PROJECTS/${brand}/${tail}`;
    }

    const brand = sanitizePathSegment(regularBrand?.name || "brand");
    return `/${brand}/PROJECTS/${tail}`;
};

export const buildCopyPath = (video: IVideo, project?: any): string => {
    const folder = buildVideoFolder(video, project);

    const currentVersion = Number(video?.version) || 1;
    const hasKey = !!video?.key;
    const nextVersion = hasKey ? currentVersion + 1 : currentVersion;

    const fileName = `${video.hash}_v${nextVersion}.mp4`;
    return `${folder}/${fileName}`;
};
